import {Injectable} from '@angular/core';
import {Observable, Subject, throwError} from "rxjs";
import {finalize, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class RecorderService {

  private recordMedia?: Media;
  private recording = false;

  private record$ = new Subject<void>();

  public get isRecording(): boolean {
    return this.recording;
  }

  constructor() {
  }

  public init(src: string): void {
    this.recordMedia = new Media(src,
      () => {
        console.log('Media operation success');
        this.record$.next();
      },  // 이 콜백은 stopRecord() 가 호출된 후 결과로 불려진다.
      err => {
        console.error('Media operation error', err)
        this.record$.error(err);
      },
      status => {
        console.log('Media operation status', status)
      });
  }


  /**
   * 녹음 시작
   *
   * NOTE: Media.startRecord()는 성공했을 때 mediaSuccess collback을 호출하지 않는다. 그래서 이 함순는 Observable을 반환할 수 없다.
   *
   * 하지만 실패했을 때에는 mediaError callback을 호출한다.
   */
  public start(): void {
    console.log('RecorderService::start()');

    if (this.recording) {
      throw new Error('RecorderService::start() - Already recording');
    }

    this.recording = true;
    this.recordMedia.startRecord();
  }


  public stop(): Observable<void> {
    console.log('RecorderService::stop()');

    if (!this.recording) {
      return throwError(new Error('RecorderService::stop() - Not recording'));
    }
    
    this.recordMedia.stopRecord();

    const endRecord = () => this.recording = false;

    return this.record$.asObservable().pipe(
      tap({
        next: endRecord,
        error: endRecord,
      }),
      // finalize(endRecord),
    );
  }
}
